import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor } from '@angular/common/http'
import * as CryptoJS from 'crypto-js';
import { en } from '../environments/environment.tok'
import { en as enk } from '../environments/environments.k'
import { Observable, tap } from 'rxjs';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SpinnerService } from './shared/spinner.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class TokenInterCepterService implements HttpInterceptor {

  constructor(private injector: Injector, private router: Router, private spinner: SpinnerService, private spinner2:NgxSpinnerService) { }

  intercept(req: any, next: any): Observable<HttpEvent<any>> {
    let tokenizedReq = req.clone({
      setHeaders: {
        1000: `bearer ${sessionStorage.getItem('1000')}`,
        1001: `${sessionStorage.getItem('1001')}`,
        1002: `${this.encryptUsingAES256(en.token)}`,
        1003: `${en.session}`,
        1005: `${sessionStorage.getItem('1005')}`,
        'X-XSS-Protection': '1; mode=block'
      }
    })
    // console.log(tokenizedReq)
    // return next.handle(tokenizedReq)
    return next.handle(tokenizedReq).pipe(
      tap({
        next: (res: any) => {
          if (res?.body?.data) {
            if (res.body.data === 'Session Expired . Please login again') {
              this.spinner.hide()
              this.spinner2.hide()
              Swal.fire({
                title: `${res.body['data']}`,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Logout!'
              }).then(async (result: any) => {
                if (result.value) {
                  sessionStorage.clear()
                  this.router.navigate(['/login'])
                  window.location.reload()
                }
              })
              throw new Error('SESSION_EXPIRED');
            }
          }
        },
        error: (err) => {
          console.error("Error response:", err);
        }
      })
    );
  }
  encryptUsingAES256(request: any) {
    let _key = CryptoJS.enc.Utf8.parse(enk.jump);
    let _iv = CryptoJS.enc.Utf8.parse(enk.jump);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(request), _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }







}
